import { QuantityRemainingTag } from 'src/pages/consumer/order/components/QuantityRemainingTag';
import { DishFirstDishCard } from 'src/shared/design-system/DishFirstDishCard';
import { DynamicImage } from 'src/shared/design-system/DynamicImage';
import { Col } from 'src/shared/design-system/Layout';
import styled, { css } from 'styled-components';
import { ScreenWidth } from 'web-common/src/shared/Constants';
import { ifNotProp } from 'web-common/src/shared/styled-utils/ifNotProp';
import { ifProp } from 'web-common/src/shared/styled-utils/ifProp';
import { Font, getSpacingMultiple, Spacing } from 'web-common/src/shared/styles';
import { DishTags } from '../DishTags';

export const DishItemContainer = styled(Col)<{ showPadding?: boolean; autoWidth?: boolean }>`
  margin-bottom: ${Spacing.SINGLE};
  border-radius: 8px;

  padding: ${ifProp('showPadding', '15px', '0px')};
  ${ifProp(
    'autoWidth',
    css`
      width: auto;
    `
  )}

  @media (max-width: ${ScreenWidth.SMALL}) {
    width: 100%;
  }
`;

export const DishSelectionItem = styled.div<{ showPointer?: boolean }>`
  // Needed for soldout absolute positioned overlays
  position: relative;
  overflow: hidden;
  background-color: white;
  display: flex;
  flex-direction: column;

  border-radius: 8px;
  box-shadow: 0 4px 5px rgba(0, 0, 0, 0.1);

  @media (min-width: ${ScreenWidth.SMALL}) {
    height: ${getSpacingMultiple(27)};
    cursor: ${ifProp('showPointer', 'pointer', 'default')};
    transition: 0.3s transform cubic-bezier(0.155, 1.105, 0.295, 1.12), 0.3s box-shadow,
      0.3s -webkit-transform cubic-bezier(0.155, 1.105, 0.295, 1.12);
  }

  @media (max-width: ${ScreenWidth.SMALL}) {
    border-radius: 8px;
  }

  :hover {
    transform: scale(1.01);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12), 0 4px 8px rgba(0, 0, 0, 0.06);
  }
`;

export const DishInfo = styled.div<{ isBigImage: boolean }>`
  min-height: 0;
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  @media (max-width: ${ScreenWidth.SMALL}) {
    /*
     * Desired layouts for various form factors:
     *
     * Desktop:
     * [        img         ]
     * [        text        ]
     *
     * Mobile (normal):
     * [  text  ][ img ]
     *
     * Mobile (popular):
     * [      img      ]
     * [      text     ]
     */
    flex-direction: ${({ isBigImage }) => (isBigImage ? 'column' : 'row-reverse')};
  }
`;

export const ImgContainer = styled.div<{ isBigImage: boolean }>`
  position: relative;
  @media (max-width: ${ScreenWidth.SMALL}) {
    align-self: ${ifNotProp('isBigImage', 'flex-start')};
    border-radius: ${ifProp('isBigImage', '0px', '4px')};
    flex-shrink: 0;
    margin: ${ifProp('isBigImage', 0, `${Spacing.SINGLE_HALF} ${Spacing.SINGLE} ${Spacing.SINGLE} ${Spacing.HALF}`)};
    overflow: hidden;
  }
`;

export const DynamicImg = styled(DynamicImage)`
  @media (min-width: ${ScreenWidth.SMALL}) {
    width: 100%;
  }

  @media (max-width: ${ScreenWidth.SMALL}) {
    border-radius: 0;
  }
`;

export const BottomContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  margin-bottom: ${Spacing.SINGLE_HALF};
  margin-top: auto;
  padding: ${Spacing.NONE} ${Spacing.SINGLE};
`;

export const ItemDetailsButton = styled.button`
  background: none;
  border: none;
  font-family: ${Font.Family.SANS};
  font-weight: ${Font.Weight.SEMI_BOLD};
  margin-left: auto;
  margin-right: auto;
`;

export const AddToCartButtonContainer = styled(BottomContainer)`
  flex-shrink: 0;
  margin: ${Spacing.NONE} ${Spacing.SINGLE} ${Spacing.SINGLE_HALF} ${Spacing.SINGLE};
  padding: ${Spacing.NONE};
`;

export const PositionedDishTags = styled(DishTags)`
  position: absolute;
  left: 10px;
  top: 10px;
`;

export const PositionedQuantityRemainingTag = styled(QuantityRemainingTag)`
  position: absolute;
  top: 0;
  right: 0;
  border-radius: 0 0 0 5px;
`;

export const DishCard = styled(DishFirstDishCard)``;
